import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Grid,
  Stack,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@mui/material";
import { FaUser } from "react-icons/fa";
import { FaPlug } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import { FaRetweet } from "react-icons/fa";
import { FaClock } from "react-icons/fa";
import { FaReply } from "react-icons/fa";

const AccordionSection2 = () => {
  const accordions = [
    "Contacts",
    "Interactions",
    "Agents",
    "Invocations",
    "Connectors",
    "Sequences",
    "Scheduler",
    "Replies",
  ];
  const schedulerPlans = [
    { scheduler: 10, price: 10 },
    { scheduler: 25, price: 20 },
    { scheduler: 50, price: 35 },
    { scheduler: 100, price: 65 },
  ];

  const smartRepliesPlans = [
    { replies: 1000, price: 10 },
    { replies: 2500, price: 20 },
    { replies: 5000, price: 35 },
    { replies: 10000, price: 65 },
  ];

  const contactPlans = [
    { contacts: 2500, price: 12 },
    { contacts: 5000, price: 25 },
    { contacts: 10000, price: 50 },
    { contacts: 25000, price: 125 },
    { contacts: 50000, price: 250 },
  ];

  const connectorPlans = [
    { connectors: 5, price: 25 },
    { connectors: 10, price: 50 },
    { connectors: 25, price: 110 },
    { connectors: 50, price: 200 },
  ];

  const interactionPlans = [
    { type: "Interactions", count: 100000, price: 50 },
    { type: "Interactions", count: 250000, price: 125 },
    { type: "Contacts", count: 10000, price: 50 },
    { type: "Interactions", count: 500000, price: 250 },
    { type: "Interactions", count: 1000000, price: 500 },
  ];

  const agentPlans = [
    { agents: 2, price: 10 },
    { agents: 5, price: 20 },
    { agents: 10, price: 40 },
    { agents: 25, price: 90 },
  ];

  const connector1Plans = [
    { invocations: 10000, price: 15 },
    { invocations: 25000, price: 37 },
    { invocations: 50000, price: 75 },
    { invocations: 100000, price: 150 },
  ];

  const sequencePlans = [
    { sequences: 50, price: 25 },
    { sequences: 100, price: 45 },
    { sequences: 250, price: 150 },
    { sequences: 500, price: 250 },
  ];

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        my: 4,
      }}
    >
      <Accordion
        sx={{
          width: {
            xl: "70%",
            lg: "90%",
            xs: "92%",
            background:
              "linear-gradient(to right, #eef6f5, #f3f4f4, #f7f5f2, #fff7ed)",
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          {/* for desktop */}
          <Stack
            sx={{
              display: { sm: "flex", xs: "none" },
              flexDirection: "column",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: {
                  xl: "21px",
                  lg: "21px",
                  md: "20px",
                  sm: "20px",
                  xs: "18px",
                },
                lineHeight: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                fontWeight: 600,
                color: "rgb(34, 34, 34)",
              }}
            >
              Bundled Packages
            </Typography>
            <Typography
              component="span"
              sx={{
                color: "#333",
                fontSize: {
                  xl: "18px",
                  lg: "18px",
                  md: "16px",
                  sm: "16px",
                  xs: "14px",
                },
              }}
            >
              {" "}
              Bundled packages let you buy extra credits at a discount after
              reaching your base plan limit, preventing interruptions. Available
              only for Ultimate Plan users.
            </Typography>
          </Stack>

          {/* for mobile */}
          <Stack
            sx={{
              display: { sm: "none", xs: "flex" },
              flexDirection: "column",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: {
                  xl: "20px",
                  lg: "20px",
                  md: "20px",
                  sm: "20px",
                  xs: "20px",
                },
                lineHeight: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                fontWeight: 600,
                color: "rgb(34, 34, 34)",
              }}
            >
              Bundled Packages
            </Typography>
            <Typography component="span">
              {" "}
              Bundled packages give discounts on credits after the base plan.
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <Grid
            container
            spacing={2}
            sx={{
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "flex-start", // Prevent sibling height equalization
            }}
          >
            {accordions.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                lg={6}
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignSelf: "flex-start", // Prevent stretching to sibling height
                }}
              >
                <Accordion
                  sx={{
                    width: "100%",
                    backgroundColor: "#fff",
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                  >
                    <Typography fontWeight="bold">{item}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {item === "Contacts" && (
                      <List>
                        {contactPlans.map((plan, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              borderBottom:
                                index < contactPlans.length - 1
                                  ? "1px solid #e0e0e0"
                                  : "none",
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar sx={{ backgroundColor: "#4caf50" }}>
                                <FaUser color="white" />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{ fontWeight: "bold", color: "#333" }}
                                >
                                  {plan.contacts.toLocaleString()} Contacts for{" "}
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#673ab7",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${plan.price}
                                  </Typography>
                                </Typography>
                              }
                              secondary={
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "12px", color: "#666" }}
                                >
                                  per month
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}

                    {item === "Connectors" && (
                      <List>
                        {connectorPlans.map((plan, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              borderBottom:
                                index < connectorPlans.length - 1
                                  ? "1px solid #e0e0e0"
                                  : "none",
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar sx={{ backgroundColor: "#673ab7" }}>
                                <FaPlug color="white" />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{ fontWeight: "bold", color: "#333" }}
                                >
                                  {plan.connectors.toLocaleString()} Connectors
                                  for{" "}
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#673ab7",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${plan.price}
                                  </Typography>
                                </Typography>
                              }
                              secondary={
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "12px", color: "#666" }}
                                >
                                  per month
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}

                    {item === "Interactions" && (
                      <List>
                        {interactionPlans.map((plan, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              borderBottom:
                                index < interactionPlans.length - 1
                                  ? "1px solid #e0e0e0"
                                  : "none",
                              backgroundColor:
                                plan.type === "Contacts"
                                  ? "#e8f5e9"
                                  : "transparent", // Highlight specific type
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar sx={{ backgroundColor: "#ffb74d" }}>
                                <FaUsers color="white" />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{ fontWeight: "bold", color: "#333" }}
                                >
                                  {plan.count.toLocaleString()} {plan.type} for{" "}
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#673ab7",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${plan.price}
                                  </Typography>
                                </Typography>
                              }
                              secondary={
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "12px", color: "#666" }}
                                >
                                  per month
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}

                    {item === "Agents" && (
                      <List>
                        {agentPlans.map((plan, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              borderBottom:
                                index < agentPlans.length - 1
                                  ? "1px solid #e0e0e0"
                                  : "none",
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar sx={{ backgroundColor: "#8bc34a" }}>
                                <FaUserTie color="white" />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{ fontWeight: "bold", color: "#333" }}
                                >
                                  {plan.agents} Agents for{" "}
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#673ab7",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${plan.price}
                                  </Typography>
                                </Typography>
                              }
                              secondary={
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "12px", color: "#666" }}
                                >
                                  per month
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}

                    {item === "Invocations" && (
                      <List>
                        {connector1Plans.map((plan, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              borderBottom:
                                index < connector1Plans.length - 1
                                  ? "1px solid #e0e0e0"
                                  : "none",
                              backgroundColor:
                                index === 2 ? "#f0fdf4" : "inherit", // Highlight for specific row
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar sx={{ backgroundColor: "#673ab7" }}>
                                <FaPlug color="white" />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{ fontWeight: "bold", color: "#333" }}
                                >
                                  {plan.invocations.toLocaleString()} Connector
                                  Invocations for{" "}
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#673ab7",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${plan.price}
                                  </Typography>
                                </Typography>
                              }
                              secondary={
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "12px", color: "#666" }}
                                >
                                  per month
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}

                    {item === "Sequences" && (
                      <List>
                        {sequencePlans.map((plan, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              borderBottom:
                                index < sequencePlans.length - 1
                                  ? "1px solid #e0e0e0"
                                  : "none",
                              backgroundColor:
                                index === 3 ? "#f0fdf4" : "inherit", // Highlight for the last row
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar sx={{ backgroundColor: "#673ab7" }}>
                                <FaRetweet color="white" />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{ fontWeight: "bold", color: "#333" }}
                                >
                                  {plan.sequences.toLocaleString()} Sequences
                                  for{" "}
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#673ab7",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${plan.price}
                                  </Typography>
                                </Typography>
                              }
                              secondary={
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "12px", color: "#666" }}
                                >
                                  per month
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}

                    {item === "Scheduler" && (
                      <List>
                        {schedulerPlans.map((plan, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              borderBottom:
                                index < schedulerPlans.length - 1
                                  ? "1px solid #e0e0e0"
                                  : "none",
                              backgroundColor:
                                index === 3 ? "#f0fdf4" : "inherit", // Highlight the last row
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar sx={{ backgroundColor: "#4caf50" }}>
                                <FaClock color="white" />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{ fontWeight: "bold", color: "#333" }}
                                >
                                  {plan.scheduler.toLocaleString()} Scheduler
                                  for{" "}
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#673ab7",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${plan.price}
                                  </Typography>
                                </Typography>
                              }
                              secondary={
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "12px", color: "#666" }}
                                >
                                  per month
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}

                    {item === "Replies" && (
                      <List>
                        {smartRepliesPlans.map((plan, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              borderBottom:
                                index < smartRepliesPlans.length - 1
                                  ? "1px solid #e0e0e0"
                                  : "none",
                              backgroundColor:
                                index === 3 ? "#f0fdf4" : "inherit", // Highlight the last row
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar sx={{ backgroundColor: "#673ab7" }}>
                                <FaReply color="white" />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{ fontWeight: "bold", color: "#333" }}
                                >
                                  {plan.replies.toLocaleString()} Smart Replies
                                  for{" "}
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#673ab7",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${plan.price}
                                  </Typography>
                                </Typography>
                              }
                              secondary={
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "12px", color: "#666" }}
                                >
                                  per month
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}
                  </AccordionDetails>
                </Accordion>
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

export default AccordionSection2;
